/**
 * groups.js
 */

import React from 'react';
import axios from 'axios';
import { useMediaQuery, Container } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { Alert } from '@mui/material';
import { UserContext } from 'contexts/user/user-context';
import { AppBarContext } from 'contexts/app-bar/app-bar-context';
import PageTitle from 'components/page-title';
import FeatureBox from 'components/feature-box';
import ManagerGroups from './manager/manager-groups';
import TrainingGroups from './training/training-groups';
import ConnectedHandlers from './connections/connected-handlers';
import { ManagerGroupsProvider } from './manager/manager-groups-context';
import { TrainingGroupsProvider } from './training/training-groups-context';
import { ConnectedHandlersProvider } from './connections/connected-handlers-context';


const useStyles = makeStyles(theme => ({
  root: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(20),
    [theme.breakpoints.down('md')]: {
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(2),
    },
  },
  section: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: theme.spacing(7),
    [theme.breakpoints.down('sm')]: {
      marginTop: theme.spacing(3)
    },
    [theme.breakpoints.up('md')]: {
      '& .captioned-svg': {
        maxWidth: 500
      }
    }
  }
}));


export default function Groups(props) {
  const classes = useStyles();
  const { user } = React.useContext(UserContext);
  const { setAppBar } = React.useContext(AppBarContext);
  const isMobile = useMediaQuery(theme => theme.breakpoints.down('sm'), { noSsr: true });
  const [isLoading, setIsLoading] = React.useState();
  const [data, setData] = React.useState();
  const isInvalidTrainer = user.role.isTrainer && data?.managedHandlerIds?.length === 0;
  const title = 'Groups';


  React.useEffect(() => {
    document.title = `PACKTRACK - ${title}`;
    setAppBar(title);

    (async() => {
      setIsLoading(true);
      const response = await axios.get('/groups');
      if (response.status === 200) {
        setData(response.data);
      }
      setIsLoading(false);
    })();
  }, [setAppBar]);


  return (
    <>
      <Container className={classes.root} data-testid='groups-page'>
        {/* desktop title */}
        {!isMobile &&
        <PageTitle iconName='group' title={title} />}

        <FeatureBox style={{ minHeight: 140 }} loading={isLoading}>
          {data &&
          <>
            <ManagerGroupsProvider managers={data.managerGroups}>
              <TrainingGroupsProvider groups={data.trainingGroups}>
                <ConnectedHandlersProvider handlers={data.connectedHandlers} managedHandlerIds={data.managedHandlerIds}>

                  {isInvalidTrainer &&
                  <Alert variant='standard' severity='warning' style={{ marginTop: 32 }}>
                    You must be training at least one handler in order to manage training groups. Invite a handler to train from the Manage page.
                  </Alert>}
                  
                  {/* MANAGER GROUPS */}
                  {user.role.isHandler &&
                  <div className={classes.section}><ManagerGroups /></div>}

                  {/* TRAINING GROUPS */}
                  {(user.role.isHandler || user.role.isTrainer) &&
                  <div className={`${classes.section}`}><TrainingGroups /></div>}

                  {/* CONNECTED HANDLERS */}
                  {(user.role.isHandler || user.role.isTrainer) &&
                  <div className={`${classes.section}`}><ConnectedHandlers /></div>}
                
                </ConnectedHandlersProvider>
              </TrainingGroupsProvider>
            </ManagerGroupsProvider>
          </>}
        </FeatureBox>
      </Container>
    </>
  )
}